import React from 'react';
import AllRoutes from './Route.jsx';
import { ToastContainer } from 'react-toastify';
import SEO from './components/SEO';
import { LogoProvider } from './contexts/LogoContext';

const App = ({ metaTags = {}, initialLogo = { isWhite: true } }) => {
  // Ensure metaTags is always an object
  const safeMetaTags = metaTags || {};

  return (
    <LogoProvider initialState={initialLogo}>
      <SEO page="home" metaTags={safeMetaTags} />
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <AllRoutes />
    </LogoProvider>
  );
};

export default App;